module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kd-La.d672b81e.png";